export default { title: 'Enviar avaliação Google' };
